import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import styled from 'styled-components';
import LinesIcon from '../icons/lines';

const SortableHandleButton = SortableHandle(() => (
  <IconBox>
    <LinesIcon width="8px" height="8px" />
  </IconBox>
));

export default SortableHandleButton;

const IconBox = styled.span`
  background-color: ${({ theme }) => theme.colors.primary};
  left: -16px;
  top: calc(50% - 16px);
  cursor: pointer;
  z-index: 20;
  position: absolute;
  border-radius: 50%;
  padding: 12px;
  display: flex;
  box-shadow: ${({ theme }) =>
    `${theme.general.boxShadowInput} ${theme.colors.shadow}`};
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
`;
